import { BottomSheet } from '@bonanza-social/navigation';
import { startListening, socketConnected } from '@bonanza-social/toolkit/state';
import { Notification, RewardType } from './rewards.types';
import { parseRewards } from './rewards.utils';
import { logInfo } from '@bonanza-social/toolkit/logging';
import { fetchSpinsCount } from '@bonanza-social/instant-wheel';

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'RewardMessageReceived',
      async (notification: Notification) => {
        const { rewards, sourceType } = notification || {};

        logInfo('WS', 'RewardMessageReceived', notification);

        if (
          !rewards ||
          sourceType === 'DailyGift' ||
          sourceType === 'CommunityEventPlayerContributionReward' ||
          sourceType === 'CommunityEventJackpotReward' ||
          sourceType === 'CommunityEventPlayerMilestoneFlipReward' ||
          sourceType === 'ItemPurchase'
        ) {
          return;
        }

        const hasInstantWheelReward = rewards.some(
          (reward) => reward.rewardType === RewardType.InstantWheel,
        );

        if (hasInstantWheelReward) {
          dispatch(fetchSpinsCount());
        }

        BottomSheet.open({
          namespace: 'rewards',
          type: 'RewardReceivedBottomSheet',
          presentAnimation: 'confetti',
          singleton: false,
          light: true,
          data: {
            rewards: parseRewards(rewards),
            questCompleted: sourceType === 'InPeriod',
          },
          scrollable: true,
          enableContentPanningGesture: false,
        });
      },
    );
  },
});
